import { render, staticRenderFns } from "./custom_tab_nav.vue?vue&type=template&id=0b9f86c1"
import script from "./custom_tab_nav.vue?vue&type=script&lang=js"
export * from "./custom_tab_nav.vue?vue&type=script&lang=js"
import style0 from "./custom_tab_nav.vue?vue&type=style&index=0&id=0b9f86c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports